import { ActorRefFrom } from 'xstate';
import { useTranslation } from 'react-i18next';
import { useSelector } from '@xstate/react';
import { useEffectOnce } from 'react-use';
import { InsuranceEnterInsuranceType } from 'domains/signup/insurance/Steps/EnterInsuranceType';
import { InsuranceEnterMedicaidProvider } from 'domains/signup/insurance/Steps/EnterMedicaidProvider';
import { InsuranceEnterUseInsurance } from 'domains/signup/insurance/Steps/EnterUseInsurance';
import { SignupContext, withSignupMachineState } from 'domains/signup/signupFlow/context/signupContext';
import { InsuranceContext } from 'domains/signup/insurance/data/insuranceEntryContext';
import { InsuranceEntryState, insuranceMachine } from 'domains/signup/insurance/insuranceMachine';
import { useActorUtilities } from 'utils/xstate/context';
import { Button, IconStartAdornment } from 'components/Button';
import { signupStateChangeListener } from 'domains/signup/data/mixpanelTracking';
import { InsuranceNotInNetwork } from 'domains/signup/insurance/Steps/InsuranceNotInNetwork';

const EnteringInsurance: React.FC = () => {
  const insuranceActor = SignupContext.useSelector(
    state => state.children.runInsuranceMachine as ActorRefFrom<typeof insuranceMachine>,
  );

  // Subscribe to log state changes with mixpanel
  useEffectOnce(() => {
    return insuranceActor.subscribe(({ value }) => {
      signupStateChangeListener(value as InsuranceEntryState);
    }).unsubscribe;
  });

  const hasBack = useSelector(insuranceActor, state => state.can({ type: 'back' }));
  const { send } = insuranceActor;

  const { t } = useTranslation();

  return (
    <InsuranceContext.Provider value={useActorUtilities(insuranceActor)}>
      {hasBack && (
        <Button
          variant="link"
          startAdornment={<IconStartAdornment name="AngleLeft" />}
          className="mb-24"
          onClick={() => send({ type: 'back' })}
        >
          {t('screener.backButton')}
        </Button>
      )}
      <InsuranceEnterUseInsurance />
      <InsuranceEnterInsuranceType />
      <InsuranceEnterMedicaidProvider />
      <InsuranceNotInNetwork />
    </InsuranceContext.Provider>
  );
};

export const SignupEnteringInsurance = withSignupMachineState(EnteringInsurance, 'enteringInsurance');
